import { io } from 'socket.io-client';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';

const socket = io(SERVER_URL, {
  autoConnect: false,
  reconnection: true,
  // Keep trying forever instead of capping at 10 attempts. After a phone
  // unlock or app switch we want the socket to recover on its own — giving
  // up leaves the UI in a frozen state with no path back besides a hard
  // refresh.
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
  timeout: 20000,
});

/** Connect with auth token (new persistent auth) */
export function connectWithAuth(token) {
  socket.auth = { token };
  socket.connect();
}

export default socket;
